/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import Moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PanelPrincipal from './detalle-allseasons/paquete-detalle-panel-comprar/paquete-detalle-panel-comprar';
import Transporte from './detalle-allseasons/paquete-detalle-transporte/paquete-detalle-transporte';
import Hoteles from './detalle-carga-manual/paquete-detalle-hoteles/paquete-detalle-hoteles';
import VacacionesAMedida from './paquete-detalle-vacaciones-medida/paquete-detalle-vacaciones-medida';
import Salida from '../paquetes-lista/salida';
import ServiciosIncluidos from './detalle-allseasons/servicios-incluidos/servicios-incluidos';
import PanelOperador from './panel-operador/panel-operador';
import Incluye from './detalle-allseasons/paquete-detalle-incluye/paquete-detalle-incluye';
import PaquetesClient from '../../api/paquetes';
import NoDisponible from '../layout/error-paquete/no-disponible';
import SeccionConTitulo from './seccion-detalle/seccion-con-titulo';
import commons from '../../commons/commons';
import WarningContainer from './warning-container';
import PanelBasico from './panel-basico/panel-basico';

class DetalleAllSeasons extends Component {
  constructor(props) {
    super(props);
    this.formatearPrecio = this.formatearPrecio.bind(this);
    this.armarSalidas = this.armarSalidas.bind(this);
    this.prepararDatosIniciarVenta = this.prepararDatosIniciarVenta.bind(this);
    this.armarDescripcionMeta = this.armarDescripcionMeta.bind(this);
    this.validateAvailability = this.validateAvailability.bind(this);
    this.armarTitulo = this.armarTitulo.bind(this);
  }

  formatearPrecio(precioNeto, impuestos, impuestoPais, iva, cantPasajeros) {
    let precioRedondeado = 0;
    if (cantPasajeros > 0) {
      precioRedondeado = Math.ceil(
        (precioNeto + impuestos + impuestoPais + iva) / cantPasajeros,
      );
    } else {
      precioRedondeado = Math.ceil(precioNeto + impuestos + impuestoPais + iva);
    }

    return this.formatNumber(precioRedondeado);
  }

  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  armarSalidas() {
    const listaSalidas = [];
    if (this.props.salidas) {
      for (let i = 0; i <= this.props.salidas.length - 1; i++) {
        if (this.props.salidaNoVisible !== i) {
          const cantPasajeros = this.props.paquete.pasajeros !== null
            ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : parseInt(this.props.cupos, 10);

          listaSalidas.push(
            <Salida
              proveedorId={this.props.proveedorId}
              distribucion={this.props.distribucion}
              indice={i}
              salidas={this.props.salidas}
              formatearPrecio={this.formatearPrecio}
              cant_pasajeros={cantPasajeros}
              key={i}
              hoteles={this.props.salidas[i].hoteles}
              datos={this.props.salidas[i]}
            />,
          );
        }
      }
    }
    return listaSalidas;
  }

  prepararDatosIniciarVenta() {
    let precioRedondeado = Math.ceil(
      this.props.paquete.salidas[0].precios.precioNeto
            + this.props.paquete.salidas[0].precios.impuestos
            + this.props.paquete.salidas[0].precios.iva,
    );
    precioRedondeado = precioRedondeado.toString();
    if (precioRedondeado.length > 4) {
      const punto = '.';
      const position = precioRedondeado.length;
      precioRedondeado = [
        precioRedondeado.slice(0, position - 3),
        punto,
        precioRedondeado.slice(-3, position),
      ].join('');
    }
    return {
      importe: precioRedondeado,
      ventaEstadoId: 1,
      ventaDetalle: this.props.paquete,
      utms: [{ id: 1, descripcion: 'sarasa' }],
    };
  }

  armarDescripcionMeta() {
    const cantPasajeros
            = this.props.paquete.pasajeros !== null ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : '1';

    const precio = this.formatearPrecio(
      this.props.paquete.salidas[0].precios.precioNeto,
      this.props.paquete.salidas[0].precios.impuestos,
      this.props.paquete.salidas[0].precios.impuestoPais,
      this.props.paquete.salidas[0].precios.iva,
      cantPasajeros,
    );

    const fechaSalida = Moment(this.props.paquete.salidas[0].fechaSalida).format(
      'DD/MM/YYYY',
    );

    return `ARS ${precio} - Fecha de salida ${fechaSalida}`;
  }

  validateAvailability(event) {
    event.preventDefault();
    const availabilityRequired = Commons.obtenerCantidadPasajeros(Commons.obtenerDistribucion());
    let queryString = '?type=Paquete';

    if (this.props.referencia !== '' && this.props.referencia !== undefined) {
      const urlString = isClient ? window.location.href : '';
      const url = new URL(urlString);
      queryString = `${'?type=Paquete&h='}${this.props.distribucion}&referencia=${this.props.referencia}&proveedorId=${this.props.proveedorId}&destino=${url.searchParams.get('d')}`;
    }

    PaquetesClient.validarCuposAllSeasons(this.props.paquete.salidas[0].id).then((totalAvailability) => {
      if (availabilityRequired <= totalAvailability) {
        if (isClient) {
          window.location.href = `${process.env.RAZZLE_URL_PATH}/checkout?t=${this.props.referencia}&h=${this.props.distribucion}&p=${this.props.paquete.proveedorId}`;
        }
      } else {
        // eslint-disable-next-line no-alert
        alert('Se agotaron los cupos para esta salida, deja tu consulta asi podremos ayudarte');
        if (isClient) {
          window.location.href = `${process.env.RAZZLE_URL_PATH}/consulta${queryString}`;
        }
      }
    });
  }

  armarTitulo() {
    const indexBr = this.props.paquete.nombre.indexOf('<br>');
    if (indexBr === -1) {
      return this.props.paquete.nombre;
    }
    return this.props.paquete.nombre.substr(0, indexBr);
  }

  validarEstadoPaquete(paquete) {
    const now = Moment();
    const desde = Moment(paquete.vigencia.desde);
    const hasta = Moment(paquete.vigencia.hasta);

    if (!!paquete?.disponible && (now <= hasta && desde <= now)) {
      return (
        this.renderizarDetalle()
      );
    }
    return (
      <NoDisponible mensaje='Más opciones para este paquete' />
    );
  }

  renderizarDetalle() {
    const { paquete, cantidadPasajeros, application, t } = this.props;

    const precioUnitario = commons.precioUnitario(paquete.salidas[0].precios, cantidadPasajeros, application.currency.code);
    const precioUnitarioFormateado = commons.numberFixedToMoney(precioUnitario, 0);

    const transporte = this.props.paquete.salidas[0].transporte.transporteAereo === null
      ? ''
      : (
        <Transporte
          transporte={this.props.paquete.salidas[0].transporte}
          ida={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda}
          vuelta={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta}
        />
      );

    return (
      <div className='listado-paquetes'>
        <div className='detalle paquete'>
          <PanelPrincipal
            precioUnitarioFormateado={precioUnitarioFormateado}
            proveedorId={this.props.proveedorId}
            distribucion={this.props.distribucion}
            paquete={this.props.paquete}
            referencia={this.props.referencia}
            formatearPrecio={this.formatearPrecio}
            cantidadPasajeros={this.props.cantidadPasajeros}
            validateAvailability={this.validateAvailability}
          />
          {paquete.salidas[0].precios.mensaje && (
            <WarningContainer>
              {paquete.salidas[0].precios.mensaje}
            </WarningContainer>
          )}
          <div className='container'>
            <br />
            <br />
            {this.props.paquete.salidas[0].length > 0 ? (
              <SeccionConTitulo titulo={t('layout:packages.details.services')}>
                <ServiciosIncluidos
                  descripcion={this.props.paquete.salidas[0].servicios}
                  iconos={this.props.paquete.salidas[0].tipoServicios}
                />
              </SeccionConTitulo>
            )
              : ''}
            { transporte !== null || transporte !== '' ? (
              <SeccionConTitulo titulo={t('layout:packages.details.transport')}>
                {transporte}
              </SeccionConTitulo>
            )
              : ''}
            {this.props.paquete.salidas[0].hoteles.length > 0 ? (
              <SeccionConTitulo titulo={t('layout:packages.details.lodging')}>
                <Hoteles
                  destinos={this.props.paquete.salidas[0].destinosHoteles}
                  hoteles={this.props.paquete.salidas[0].hoteles}
                />
              </SeccionConTitulo>
            )
              : ''}
            {this.props.paquete.metaDescripcion !== null && (
              <SeccionConTitulo titulo={t('layout:packages.details.description')}>
                <PanelBasico contenido={<Incluye descripcion={this.props.paquete.metaDescripcion} />} />
              </SeccionConTitulo>
            )}
            <SeccionConTitulo>
              <VacacionesAMedida
                referencia={this.props.referencia}
                proveedorId={this.props.proveedorId}
                destino={this.props.paquete.salidas[0].destinoIata}
                fechaSalida={this.props.paquete.salidas[0].fechaSalida}
                cantidadNoches={this.props.paquete.cantNoches}
              />
            </SeccionConTitulo>
            <SeccionConTitulo>
              <PanelOperador
                datos={this.props.paquete.operadorResponsable}
              />
            </SeccionConTitulo>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.paquete !== undefined
          ? this.validarEstadoPaquete(this.props.paquete)
          : ''}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  application: state.applicationState,
});

export default connect(mapStateToProps, null)(withTranslation()(DetalleAllSeasons));
